export const COLORS = {
  primaryBlue: "#39f",
  gray: "#eee",
  black: "#000",
  darkGray: "#b3b3b3",
  darkerGray: "#808080",
  dangerRed: "#fa634f",
  alertYellow: "#ffe845",
  successGreen: "#32CD32",
  primaryOrange: "#fa914f",
  graphColors: [
    "#39f",
    "#fa634f",
    "#ffe845",
    "#8884d8",
    "#82ca9d",
    "#4f55fa",
    "#fa4fe3",
    "#bb4ffa",
    "#4ffa93",
    "#fa914f",
    "#fa4f6c",
    "#4fcffa",
    "#584ffa",
    "#e23636",
    "#36e268",
    "#9b36e2",
    "#e2cd36",
    "#36c6e2",
    "#e23693",
    "#61e236",
    "#3e36e2",
    "#e27036",
    "#36e2a2",
    "#d436e2",
    "#bee236",
    "#368ce2",
    "#e2365a",
    "#36e245",
    "#7736e2",
    "#e2a936",
    "#36e2dc",
    "#e236b7",
    "#85e236",
    "#3652e2",
    "#e24c36",
    "#36e27e",
    "#b136e2",
    "#e2e236",
    "#36b0e2",
    "#e2367d",
    "#4be236",
    "#5436e2",
    "#e28636",
    "#36e2b8",
    "#e236da",
    "#a8e236",
    "#3676e2",
    "#e23649",
    "#36e256",
    "#8836e2",
    "#e2ba36",
    "#e236a6",
    "#74e236",
    "#e25d36",
    "#36e28f",
    "#c236e2",
    "#d1e236",
    "#369fe2",
    "#e2366c",
    "#3ae236",
  ],
};

export const LINE_DATA = [
  [
    { label: "Date 1", val: 15 },
    { label: "Date 2", val: 12 },
    { label: "Date 3", val: 8 },
    { label: "Date 4", val: 20 },
    { label: "Date 5", val: 18 },
    { label: "Date 6", val: 14 },
    { label: "Date 7", val: 10 },
    { label: "Date 8", val: 10 },
    { label: "Date 9", val: 15 },
    { label: "Date 10", val: 9 },
  ],
  [
    { label: "Date 1", val: 3 },
    { label: "Date 2", val: 7 },
    { label: "Date 3", val: 12 },
    { label: "Date 4", val: 13 },
    { label: "Date 5", val: 18 },
    { label: "Date 6", val: 14 },
    { label: "Date 7", val: 7 },
    { label: "Date 8", val: 13 },
    { label: "Date 9", val: 15 },
    { label: "Date 10", val: 9 },
  ],
];

export const DROPDOWNS = {
  GROWING_ENVIRONMENTS: [
    {
      label: "Green House",
      value: "Green House",
    },
    {
      label: "Glass House",
      value: "Glass House",
    },
    {
      label: "Open Field",
      value: "Open Field",
    },
  ],
  BAR_SORT_DATA: [
    {
      label: "Ascending by Value",
      key: "ascVal",
    },
    {
      label: "Descending by Value",
      key: "dscVal",
    },
    {
      label: "Ascending by Plot Name",
      key: "ascName",
    },
    {
      label: "Descending by Plot Name",
      key: "dscName",
    },
  ],
  BAR_LIMIT_DATA: [
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "15",
      value: 15,
    },
    {
      label: "20",
      value: 20,
    },
    {
      label: "25",
      value: 25,
    },
  ],
};

export const WHITELIST_401 = [
  "/login",
  "/logout",
  "/reset-password",
  "/refresh",
];

export const IMAGE_CONTENT_TYPES = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  bmp: "image/bmp",
  svg: "image/svg+xml",
  webp: "image/webp",
};

export const TOUR_MODAL_STYLES = {
  options: {
    arrowColor: COLORS.primaryBlue,
    backgroundColor: COLORS.primaryBlue,
    overlayColor: "rgba(0,0,0,0.8)",
    primaryColor: COLORS.successGreen,
    textColor: "white",
    width: 500,
    zIndex: 1000,
  },
};

export const ORGANIZATION = {
  BREEDER: "Breeder",
  GROWER: "Grower",
  POLLINATION: "Pollination",
};

export const CROP = {
  TOMATO: "tomato",
  BROCCOLI: "broccoli",
  SPINACH: "spinach",
};

export const UI_DATE_FORMAT = "Do MMM, YYYY";
export const BACKEND_DATE_FORMAT = "YYYY-MM-DD";

export const getResponsiveFontSize = () => {
  const width = window.innerWidth;
  if (width < 640) {
    return 12;
  } else if (width < 1024) {
    return 14;
  }
  return 16;
};

export const getResponsiveLargeFontSize = () => {
  const width = window.innerWidth;
  if (width < 640) {
    return 14;
  } else if (width < 1024) {
    return 16;
  }
  return 18;
};
